module.exports = __webpack_public_path__ + "img/slider4.384379f1.jpg";